import { render } from "./BalanceBlock.vue?vue&type=template&id=381817e7"
import script from "./BalanceBlock.vue?vue&type=script&lang=js"
export * from "./BalanceBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__